import { Waves } from "lucide-react"
import React from "react"

const PhotoPlaceholder = () => {
  return (
    <div
      className="w-full h-full flex items-center justify-center"
      style={{ background: "linear-gradient(135deg, #4C5A6E 0%, #26303D 100%)" }}
    >
      <Waves size={28} className="text-white/40" />
    </div>
  )
}

export default PhotoPlaceholder
